// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/** Ripples */\n/** Elements */\n/* Palette generated by Material Palette - materialpalette.com/blue/amber */\n/** Ripples */\n/** Elements */\n.text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 70px;\n  margin-bottom: 3px;\n}\n.item {\n  margin-left: auto;\n  margin-right: auto;\n}", ""]);
// Exports
module.exports = exports;
